import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useCajaStore = defineStore('caja', {
  state: () => ({
    cajas: [],
    lastCaja: { fecha: new Date() },
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalCajas: 0,
    totalPages: 1
  }),
  actions: {
    async fetchCajas({ page, rows, search, perPage, fecha = null } = {}) {
      console.log('fecha CAJA STORE', fecha)
      try {
        const response = await api.get('/cajas', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.cajas = response.data.items
        this.totalCajas = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.cajas
      } catch (error) {
        console.error('Error fetching cajas:', error)
        throw error
      }
    },
    async createCaja(caja) {
      try {
        const response = await api.post('/cajas', caja, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.cajas.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error adding caja:', error)
        throw error
      }
    },
    async updateCaja(caja) {
      console.log('caja', caja)
      try {
        const response = await api.put(`/cajas/${caja.id}`, caja, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.cajas.findIndex((c) => c.id === caja.id)
        if (index !== -1) {
          this.cajas[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error updating caja:', error)
        throw error
      }
    },
    async closeCaja(caja) {
      console.log('caja', caja)
      try {
        const response = await api.put(`/cajas/close/${caja.id}`, caja, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.lastCaja = response.data
        return response.data
      } catch (error) {
        console.error('Error updating caja:', error)
        throw error
      }
    },
    async deleteCaja(id) {
      try {
        await api.delete(`/cajas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.cajas = this.cajas.filter((c) => c.id !== id)
      } catch (error) {
        console.error('Error deleting caja:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getCaja(id) {
      try {
        const response = await api.get(`/cajas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error getting caja:', error)
        throw error
      }
    },
    async getLastCaja() {
      try {
        const response = await api.get(`/cajas/get-last`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.lastCaja = response.data
        return response.data
      } catch (error) {
        console.error('Error getting caja:', error)
        throw error
      }
    },
    async getLastCajaInfo() {
      try {
        const response = await api.get(`/cajas/get-last-info`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error getting caja:', error)
        throw error
      }
    }
  }
})
